import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {},
    components: {
        batchDetailConfigPage: {
            component: 'Viewport',
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    breadcrumbName: '商品管理',
                    component: 'Viewport',
                    childRoutes: [
                        {
                            path: '/batchDetailConfig',
                            component: 'batchDetailConfigPage',
                            breadcrumbName: '移动端详情批量配置',
                            childRoutes: [
                                {
                                    path: '/add',
                                    component: 'BatchDetailConfigAddEdit',
                                    breadcrumbName: '新建规则',
                                },
                                {
                                    path: '/edit/:id',
                                    component: 'BatchDetailConfigAddEdit',
                                    breadcrumbName: '编辑规则',
                                },
                                {
                                    path: '/',
                                    component: 'BatchDetailConfigListView',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
